import React from 'react';
import { NodonListItemResult } from '@ui/ListItemResult';
import { getGeographicalAdjustmentFactor } from '@shared/helpers/energy/city-climate.helpers';
import {
  AIR_LEAKAGE_Q50,
  DEFAULT_INDOOR_TEMP,
  REGULATION_LOSS_FACTOR,
} from '@shared/helpers/energy/energy.models';
import { useBuildingLocation } from '@features/design/hooks/design.hooks';
import { useHeatedArea } from '@features/energy/energy.hook';

export const ConstantsGroup: React.FC = () => {
  const heatedArea = useHeatedArea();
  const location = useBuildingLocation();
  const geoFactor = getGeographicalAdjustmentFactor(location);

  return (
    <NodonListItemResult
      name="Constants"
      tooltip="Constants or values calculated based on location"
    >
      <NodonListItemResult
        name="Heated area"
        tooltip="The area of the building that is heated"
        value={heatedArea}
        unit="m^2"
        indentation={1}
      />
      {/* Geographical adjustment factor */}
      <NodonListItemResult
        name="Geographical adjustment factor"
        tooltip="An adjustment factor to account for the geographical location of the building. Colder temperatures allows for more energy to be used for heating."
        value={geoFactor}
        indentation={1}
      />
      {/* Indoor temperature */}
      <NodonListItemResult
        name="Indoor temperature"
        tooltip="The desired indoor temperature of the building. Currently not editable."
        value={DEFAULT_INDOOR_TEMP}
        unit="°C"
        indentation={1}
      />

      {/* Air leakage */}
      <NodonListItemResult
        name="Air leakage"
        tooltip="How much air per square meter of heated area that leaks out of the building every second."
        unit="l/s"
        value={AIR_LEAKAGE_Q50}
        indentation={1}
      />

      {/* Regulation losses */}
      <NodonListItemResult
        name="Regulation losses"
        tooltip="How much heat is lost through regulation losses. Basically inefficiencies in the system control."
        unit="%"
        value={REGULATION_LOSS_FACTOR}
        indentation={1}
      />
    </NodonListItemResult>
  );
};
